import InnerHTMLWithScript from "../../../components/innerhtmlwithscript/innerhtmlwithscript";
import SBEditable from "../../../components/sbEditable/sbEditable";
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import styles from "./instagramembed.module.scss"

const INSTAGRAM_SCRIPT =
  '<script async src="//www.instagram.com/embed.js"></script>';

function InstagramEmbed({ blok }) {
  //Add the instagram script tag for those that don't have it
  // If it is already there helmet will remove the duplicate
  const instagramWithScript = blok.instagram + INSTAGRAM_SCRIPT;

  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div
        className={`${styles.instagram} div-align-${blok.alignment || "left"}`}
        style={{ maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520 }}
      >
        <InnerHTMLWithScript id={blok._uid} text={instagramWithScript} />
      </div>
    </SBEditable>
  );
}

export default InstagramEmbed;